import React, { useCallback, useContext } from 'react';
import { Helmet } from 'react-helmet';
import EliteMindDashboard from './EliteMindDashboard';
import { SidebarContext } from '../../../../context/SidebarContext';
import { useCompanySectionFilter } from '../../../../component/B2B/CompanySectionLayout';
import { fetchCompanyEliteMindDashboard } from './companyEliteMindApi';

/** Company Elite Mind → Squad dashboard, scoped to this company. */
const CEliteMindDashboard = () => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const { department } = useCompanySectionFilter();

  const fetcher = useCallback(
    () => fetchCompanyEliteMindDashboard(department),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isB2BFansMode, department]
  );

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Elite Mind | Shoorah</title>
      </Helmet>
      <EliteMindDashboard fetcher={fetcher} populationLabel="athletes" />
    </div>
  );
};

export default CEliteMindDashboard;
